export const ROAD_STATUSES = {
    dry: {
        code: 1,
        caption: "Сухо"
    },
    damp: {
        code: 2,
        caption: "Влажное покрытие"
    },
    wet: {
        code: 3,
        caption: "Мокрое покрытие"
    },
    slush: {
        code: 4,
        caption: "Слякоть"
    },
    ice: {
        code: 5,
        caption: "Гололёд (лёд)"
    },
    snow: {
        code: 6,
        caption: "Снег на покрытии"
    },
    pgm: {
        code: 9,
        caption: "Обработано ПГМ (противогололёдный материал)"
    },
    snow_and_ice: {
        code: 10,
        caption: "Снег и лёд"
    },
    dry_and_snow_and_ice: {
        code: 11,
        caption: "Сухо, местами снег и лёд"
    },
    snow_and_sand: {
        code: 49,
        caption: "Снег и песок"
    },
};